import { SET_ORDER } from '../constants/order/actionTypes'

export const setOrder = (payload) => ({
    type: SET_ORDER,
    payload
})
